import { View } from 'react-native';
import BottomSheet, {
  BottomSheetBackdropProps,
  BottomSheetScrollView,
} from '@gorhom/bottom-sheet';
import React, { useCallback, useMemo, useRef } from 'react';
import MobileMap from './mobileMap';
import { useAppTheme } from '../theme';
import BusinessList from './businessList';
import FilterButton from './filterButton';
import BusinessListSearch from './businessListSearch';
import { useAppSelector } from '../redux/hooks';
import MapView from 'react-native-maps';

export default function MyBottomSheet() {
  const theme = useAppTheme();
  const { selectedBusiness } = useAppSelector((state) => state.businessList);

  const bottomSheetRef = useRef<BottomSheet>(null);
  const mapRef = useRef<MapView>(null);
  const snapPoints = useMemo(() => ['15%', '30%', '45%', '95%'], []);

  const renderMobileMap = useCallback(
    (props: BottomSheetBackdropProps) => (
      <MobileMap {...props} mapRef={mapRef} bottomSheetRef={bottomSheetRef} />
    ),
    []
  );

  return (
    <View>
      <BottomSheet
        ref={bottomSheetRef}
        snapPoints={snapPoints}
        enableContentPanningGesture
        backgroundStyle={{ backgroundColor: theme.colors.background }}
        backdropComponent={renderMobileMap}
        handleIndicatorStyle={{
          backgroundColor: theme.colors.handleColor,
          height: 8,
          width: 38,
        }}
        handleStyle={{
          backgroundColor: theme.colors.background,
          borderRadius: 16,
        }}
      >
        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-around',
            marginHorizontal: 12,
            marginTop: 12,
            marginBottom: 14,
          }}
        >
          {!selectedBusiness && (
            <>
              <BusinessListSearch bottomSheetRef={bottomSheetRef} />
              <FilterButton />
            </>
          )}
        </View>
        <BottomSheetScrollView style={{ margin: 6 }}>
          <BusinessList bottomSheetRef={bottomSheetRef} mapRef={mapRef} />
        </BottomSheetScrollView>
      </BottomSheet>
    </View>
  );
}
